import React from 'react';
import styled from 'styled-components/macro';
import { ButtonInvertedLink } from '../../../UI/Button/Button';
import TasklyPreviewImg from '../../../../assets/images/TasklyPreview@2x.png';

const Background = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  /* background: #6c7e87; */
  background: #63737b;
  height: 360px;
  width: 100%;
`;

const TextMobile = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Title = styled.div`
  margin: 16px 0 8px;
  color: #fff;
  font-family: miller-display, serif;
  font-weight: 600;
  font-style: normal;
  font-size: 32px;
  width: 100%;
`;

const SubTitle = styled.div`
  width: 100%;
  color: #fff;
  font-family: Lato;
  font-weight: 400;
  font-style: normal;
  font-size: 16px;
`;

const ButtonWrapper = styled.div`
  text-align: center;
  margin-bottom: 16px;
  width: 100%;
`;

const PreviewImgWrapper = styled.div`
  height: 210px;
`;

const BackgroundDesktop = styled(Background)`
  flex-direction: row;
  justify-content: center;
  height: 500px;
`;

const PreviewWrapperDesktop = styled.div`
  display: flex;
  justify-content: space-between;
  width: 700px;
  height: 300px;
`;

const TextAndButtonDesktop = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const TextDesktop = styled.div`
  display: flex;
  flex-direction: column;
`;

const TitleDesktop = styled(Title)`
  margin: 16px 0 12px;
  text-align: left;
`;

const SubTitleDesktop = styled(SubTitle)`
  font-weight: 400;
  text-align: left;
  line-height: 23px;
  width: 310px;
`;

const ButtonWrapperDesktop = styled.div`
  display: flex;
`;

const PreviewImgWrapperDesktop = styled.div`
  height: 300px;
`;

const PreviewImg = styled.img`
  height: 100%;
  width: auto;
`;

const PreviewMobile = () => (
  <Background>
    <TextMobile>
      <Title>taskly</Title>
      <SubTitle>Designing a brand new family organizer</SubTitle>
    </TextMobile>
    <PreviewImgWrapper>
      <PreviewImg src={TasklyPreviewImg} alt="TasklyPreview"></PreviewImg>
    </PreviewImgWrapper>
    <ButtonWrapper>
      <ButtonInvertedLink exact="true" to="/work/taskly">
        View Case Study
      </ButtonInvertedLink>
    </ButtonWrapper>
  </Background>
);

const PreviewDesktop = () => (
  <BackgroundDesktop>
    <PreviewWrapperDesktop>
      <TextAndButtonDesktop>
        <TextDesktop>
          <TitleDesktop>taskly</TitleDesktop>
          <SubTitleDesktop>
            Designing a brand new family organizer <br />
            <br />
            Taskly is an all-in-one family organizer that helps families stay
            connected and make more time for the things that really matter. It’s
            an easy-to-use family calendar, meal planner, task- and project
            manager.
          </SubTitleDesktop>
        </TextDesktop>
        <ButtonWrapperDesktop>
          <ButtonInvertedLink exact="true" to="/work/taskly">
            View Case Study
          </ButtonInvertedLink>
        </ButtonWrapperDesktop>
      </TextAndButtonDesktop>
      <PreviewImgWrapperDesktop>
        <PreviewImg src={TasklyPreviewImg} alt="TasklyPreview"></PreviewImg>
      </PreviewImgWrapperDesktop>
    </PreviewWrapperDesktop>
  </BackgroundDesktop>
);

const TasklyPreview = (props) => {
  // const mq = window.matchMedia('(max-width: 400px)');

  return (
    <>
      {props.desktop ? <PreviewDesktop /> : <PreviewMobile />}
      {/* {isMobile && window.matchMedia('(max-width: 768px)').matches ? (
        <PreviewMobile />
      ) : (
        <PreviewDesktop />
      )} */}
    </>
    // <Background>
    //   {isMobile && document.documentElement.clientWidth < 400 ? (
    //     <PreviewMobile />
    //   ) : (
    //     <PreviewDesktop />
    //   )}
    // </Background>

    // <Background>
    //   {isMobile && mq.matches ? (
    //     <PreviewMobile />
    //   ) : (
    //     <PreviewDesktop />
    //   )}
    // </Background>
  );
};

export default TasklyPreview;
